
import { useToast } from "@/hooks/use-toast";
import { trackEvent } from "@/integrations/posthog/client";

export const useShareEvent = () => {
  const { toast } = useToast();

  const shareEvent = async (eventId: string) => {
    // Use the new RSVP route instead of the feedback route
    const rsvpUrl = `${window.location.origin}/events/${eventId}/rsvp`;
    const isMobileShare = navigator.share && window.matchMedia('(max-width: 768px)').matches;
    
    try {
      if (isMobileShare) {
        try {
          await navigator.share({
            title: 'RSVP to Event',
            text: 'You\'re invited! RSVP via the link.',
            url: rsvpUrl,
          });
          toast({
            title: "Success",
            description: "Event shared successfully",
          });
          
          // Track successful mobile share
          trackEvent('event_shared', { method: 'mobile_share', event_id: eventId });
        } catch (shareError) {
          // If mobile share fails, fallback to clipboard
          await navigator.clipboard.writeText(rsvpUrl);
          toast({
            title: "Success",
            description: "Link copied to clipboard",
          });
          
          // Track clipboard fallback
          trackEvent('event_shared', { method: 'clipboard_fallback', event_id: eventId });
        }
      } else {
        // Use clipboard API for desktop
        await navigator.clipboard.writeText(rsvpUrl);
        toast({
          title: "Success",
          description: "Link copied to clipboard",
        });
        
        // Track desktop share
        trackEvent('event_shared', { method: 'clipboard', event_id: eventId });
      }
    } catch (error) {
      console.error('Share failed:', error);
      toast({
        title: "Error",
        description: "Unable to share. Please try copying the link manually.",
        variant: "destructive",
      });
      
      // Track share error
      trackEvent('event_share_error', { error: String(error), event_id: eventId });
      throw error;
    }
  };

  return { shareEvent };
};
